import { HardwareItemUnit } from '../enums/hardware-item-unit.enum';

export const OBSESSED_ENGINEERING_COMPONENT_UNITS = [
    HardwareItemUnit.Feet,
    HardwareItemUnit.Inches,
    HardwareItemUnit.Pieces,
] as const;

export type ObsessedEngineeringComponentUnit = typeof OBSESSED_ENGINEERING_COMPONENT_UNITS[number];

export enum ObsessedEngineeringComponentType {
    MetalsSupplied = 'Metals Supplied',
    CustomerSupplied = 'Customer Supplied',
}

export interface ObsessedEngineeringComponent {
    id: string;
    partNumber: string;
    customerPartNumber: string;
    description: string;
    imageUrl: string;
    thumbnailImageUrl: string;
    qtyOnHand: number;
    units: ObsessedEngineeringComponentUnit;
    type: ObsessedEngineeringComponentType;
    metalsProductId: string;
    /** Unit cost in the component's measurement units; null for Customer Supplied or unpriced components. */
    manufacturingCost: number | null;
}
